/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as AuthenticatedWorkspaceIdRouteRouteImport } from './routes/_authenticated/$workspaceId/route'
import { Route as AuthenticatedWorkspaceIdIndexRouteImport } from './routes/_authenticated/$workspaceId/index'
import { Route as AuthenticatedWorkspaceIdAgentRouteRouteImport } from './routes/_authenticated/$workspaceId/agent/route'
import { Route as AuthenticatedWorkspaceIdPatternsIndexRouteImport } from './routes/_authenticated/$workspaceId/patterns/index'
import { Route as AuthenticatedWorkspaceIdEntitiesIndexRouteImport } from './routes/_authenticated/$workspaceId/entities/index'
import { Route as AuthenticatedWorkspaceIdPatternsPatternIdIndexRouteImport } from './routes/_authenticated/$workspaceId/patterns/$patternId/index'
import { Route as AuthenticatedWorkspaceIdClaimsClaimIdIndexRouteImport } from './routes/_authenticated/$workspaceId/claims/$claimId/index'

const authForgotPasswordLazyRouteImport = createFileRoute(
  '/(auth)/forgot-password',
)()
const authCallbackLazyRouteImport = createFileRoute('/(auth)/callback')()
const AuthenticatedWorkspaceIdTopicsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/topics/',
)()
const AuthenticatedWorkspaceIdHomeIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/home/',
)()
const AuthenticatedWorkspaceIdGovernanceIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/governance/',
)()
const AuthenticatedWorkspaceIdFilesIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/files/',
)()
const AuthenticatedWorkspaceIdEvidenceIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/evidence/',
)()
const AuthenticatedWorkspaceIdDecisionIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/decision/',
)()
const AuthenticatedWorkspaceIdCoverageIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/coverage/',
)()
const AuthenticatedWorkspaceIdClaimsIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/claims/',
)()
const AuthenticatedWorkspaceIdAgentIndexLazyRouteImport = createFileRoute(
  '/_authenticated/$workspaceId/agent/',
)()
const AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/topics/$topicId/')()
const AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRouteImport =
  createFileRoute('/_authenticated/$workspaceId/agent/$conversationId/')()

const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any).lazy(() =>
  import('./routes/_authenticated/index.lazy').then((d) => d.Route),
)
const authForgotPasswordLazyRoute = authForgotPasswordLazyRouteImport
  .update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() =>
    import('./routes/(auth)/forgot-password.lazy').then((d) => d.Route),
  )
const authCallbackLazyRoute = authCallbackLazyRouteImport
  .update({
    id: '/callback',
    path: '/callback',
    getParentRoute: () => authRouteRoute,
  } as any)
  .lazy(() => import('./routes/(auth)/callback.lazy').then((d) => d.Route))
const authSignInRoute = authSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => authRouteRoute,
} as any)
const AuthenticatedWorkspaceIdRouteRoute =
  AuthenticatedWorkspaceIdRouteRouteImport.update({
    id: '/$workspaceId',
    path: '/$workspaceId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/route.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdIndexRoute =
  AuthenticatedWorkspaceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedWorkspaceIdAgentRouteRoute =
  AuthenticatedWorkspaceIdAgentRouteRouteImport.update({
    id: '/agent',
    path: '/agent',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any)
const AuthenticatedWorkspaceIdTopicsIndexLazyRoute =
  AuthenticatedWorkspaceIdTopicsIndexLazyRouteImport.update({
    id: '/topics/',
    path: '/topics/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/topics/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdHomeIndexLazyRoute =
  AuthenticatedWorkspaceIdHomeIndexLazyRouteImport.update({
    id: '/home/',
    path: '/home/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/home/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdGovernanceIndexLazyRoute =
  AuthenticatedWorkspaceIdGovernanceIndexLazyRouteImport.update({
    id: '/governance/',
    path: '/governance/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/governance/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdFilesIndexLazyRoute =
  AuthenticatedWorkspaceIdFilesIndexLazyRouteImport.update({
    id: '/files/',
    path: '/files/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/files/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdEvidenceIndexLazyRoute =
  AuthenticatedWorkspaceIdEvidenceIndexLazyRouteImport.update({
    id: '/evidence/',
    path: '/evidence/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/evidence/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdDecisionIndexLazyRoute =
  AuthenticatedWorkspaceIdDecisionIndexLazyRouteImport.update({
    id: '/decision/',
    path: '/decision/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/decision/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdCoverageIndexLazyRoute =
  AuthenticatedWorkspaceIdCoverageIndexLazyRouteImport.update({
    id: '/coverage/',
    path: '/coverage/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/coverage/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdClaimsIndexLazyRoute =
  AuthenticatedWorkspaceIdClaimsIndexLazyRouteImport.update({
    id: '/claims/',
    path: '/claims/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/claims/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdAgentIndexLazyRoute =
  AuthenticatedWorkspaceIdAgentIndexLazyRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkspaceIdAgentRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/agent/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdPatternsIndexRoute =
  AuthenticatedWorkspaceIdPatternsIndexRouteImport.update({
    id: '/patterns/',
    path: '/patterns/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/patterns/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdEntitiesIndexRoute =
  AuthenticatedWorkspaceIdEntitiesIndexRouteImport.update({
    id: '/entities/',
    path: '/entities/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import('./routes/_authenticated/$workspaceId/entities/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRoute =
  AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRouteImport.update({
    id: '/topics/$topicId/',
    path: '/topics/$topicId/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/topics/$topicId/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute =
  AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRouteImport.update({
    id: '/$conversationId/',
    path: '/$conversationId/',
    getParentRoute: () => AuthenticatedWorkspaceIdAgentRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/agent/$conversationId/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdPatternsPatternIdIndexRoute =
  AuthenticatedWorkspaceIdPatternsPatternIdIndexRouteImport.update({
    id: '/patterns/$patternId/',
    path: '/patterns/$patternId/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/patterns/$patternId/index.lazy'
    ).then((d) => d.Route),
  )
const AuthenticatedWorkspaceIdClaimsClaimIdIndexRoute =
  AuthenticatedWorkspaceIdClaimsClaimIdIndexRouteImport.update({
    id: '/claims/$claimId/',
    path: '/claims/$claimId/',
    getParentRoute: () => AuthenticatedWorkspaceIdRouteRoute,
  } as any).lazy(() =>
    import(
      './routes/_authenticated/$workspaceId/claims/$claimId/index.lazy'
    ).then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/logout': typeof LogoutRoute
  '/$workspaceId': typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  '/sign-in': typeof authSignInRoute
  '/callback': typeof authCallbackLazyRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/$workspaceId/agent': typeof AuthenticatedWorkspaceIdAgentRouteRouteWithChildren
  '/$workspaceId/': typeof AuthenticatedWorkspaceIdIndexRoute
  '/$workspaceId/entities': typeof AuthenticatedWorkspaceIdEntitiesIndexRoute
  '/$workspaceId/patterns': typeof AuthenticatedWorkspaceIdPatternsIndexRoute
  '/$workspaceId/agent/': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/$workspaceId/claims': typeof AuthenticatedWorkspaceIdClaimsIndexLazyRoute
  '/$workspaceId/coverage': typeof AuthenticatedWorkspaceIdCoverageIndexLazyRoute
  '/$workspaceId/decision': typeof AuthenticatedWorkspaceIdDecisionIndexLazyRoute
  '/$workspaceId/evidence': typeof AuthenticatedWorkspaceIdEvidenceIndexLazyRoute
  '/$workspaceId/files': typeof AuthenticatedWorkspaceIdFilesIndexLazyRoute
  '/$workspaceId/governance': typeof AuthenticatedWorkspaceIdGovernanceIndexLazyRoute
  '/$workspaceId/home': typeof AuthenticatedWorkspaceIdHomeIndexLazyRoute
  '/$workspaceId/topics': typeof AuthenticatedWorkspaceIdTopicsIndexLazyRoute
  '/$workspaceId/claims/$claimId': typeof AuthenticatedWorkspaceIdClaimsClaimIdIndexRoute
  '/$workspaceId/patterns/$patternId': typeof AuthenticatedWorkspaceIdPatternsPatternIdIndexRoute
  '/$workspaceId/agent/$conversationId': typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute
  '/$workspaceId/topics/$topicId': typeof AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRoute
}
export interface FileRoutesByTo {
  '/logout': typeof LogoutRoute
  '/sign-in': typeof authSignInRoute
  '/callback': typeof authCallbackLazyRoute
  '/forgot-password': typeof authForgotPasswordLazyRoute
  '/': typeof AuthenticatedIndexRoute
  '/$workspaceId': typeof AuthenticatedWorkspaceIdIndexRoute
  '/$workspaceId/entities': typeof AuthenticatedWorkspaceIdEntitiesIndexRoute
  '/$workspaceId/patterns': typeof AuthenticatedWorkspaceIdPatternsIndexRoute
  '/$workspaceId/agent': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/$workspaceId/claims': typeof AuthenticatedWorkspaceIdClaimsIndexLazyRoute
  '/$workspaceId/coverage': typeof AuthenticatedWorkspaceIdCoverageIndexLazyRoute
  '/$workspaceId/decision': typeof AuthenticatedWorkspaceIdDecisionIndexLazyRoute
  '/$workspaceId/evidence': typeof AuthenticatedWorkspaceIdEvidenceIndexLazyRoute
  '/$workspaceId/files': typeof AuthenticatedWorkspaceIdFilesIndexLazyRoute
  '/$workspaceId/governance': typeof AuthenticatedWorkspaceIdGovernanceIndexLazyRoute
  '/$workspaceId/home': typeof AuthenticatedWorkspaceIdHomeIndexLazyRoute
  '/$workspaceId/topics': typeof AuthenticatedWorkspaceIdTopicsIndexLazyRoute
  '/$workspaceId/claims/$claimId': typeof AuthenticatedWorkspaceIdClaimsClaimIdIndexRoute
  '/$workspaceId/patterns/$patternId': typeof AuthenticatedWorkspaceIdPatternsPatternIdIndexRoute
  '/$workspaceId/agent/$conversationId': typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute
  '/$workspaceId/topics/$topicId': typeof AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(auth)': typeof authRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/logout': typeof LogoutRoute
  '/_authenticated/$workspaceId': typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/callback': typeof authCallbackLazyRoute
  '/(auth)/forgot-password': typeof authForgotPasswordLazyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$workspaceId/agent': typeof AuthenticatedWorkspaceIdAgentRouteRouteWithChildren
  '/_authenticated/$workspaceId/': typeof AuthenticatedWorkspaceIdIndexRoute
  '/_authenticated/$workspaceId/entities/': typeof AuthenticatedWorkspaceIdEntitiesIndexRoute
  '/_authenticated/$workspaceId/patterns/': typeof AuthenticatedWorkspaceIdPatternsIndexRoute
  '/_authenticated/$workspaceId/agent/': typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  '/_authenticated/$workspaceId/claims/': typeof AuthenticatedWorkspaceIdClaimsIndexLazyRoute
  '/_authenticated/$workspaceId/coverage/': typeof AuthenticatedWorkspaceIdCoverageIndexLazyRoute
  '/_authenticated/$workspaceId/decision/': typeof AuthenticatedWorkspaceIdDecisionIndexLazyRoute
  '/_authenticated/$workspaceId/evidence/': typeof AuthenticatedWorkspaceIdEvidenceIndexLazyRoute
  '/_authenticated/$workspaceId/files/': typeof AuthenticatedWorkspaceIdFilesIndexLazyRoute
  '/_authenticated/$workspaceId/governance/': typeof AuthenticatedWorkspaceIdGovernanceIndexLazyRoute
  '/_authenticated/$workspaceId/home/': typeof AuthenticatedWorkspaceIdHomeIndexLazyRoute
  '/_authenticated/$workspaceId/topics/': typeof AuthenticatedWorkspaceIdTopicsIndexLazyRoute
  '/_authenticated/$workspaceId/claims/$claimId/': typeof AuthenticatedWorkspaceIdClaimsClaimIdIndexRoute
  '/_authenticated/$workspaceId/patterns/$patternId/': typeof AuthenticatedWorkspaceIdPatternsPatternIdIndexRoute
  '/_authenticated/$workspaceId/agent/$conversationId/': typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute
  '/_authenticated/$workspaceId/topics/$topicId/': typeof AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/logout'
    | '/$workspaceId'
    | '/sign-in'
    | '/callback'
    | '/forgot-password'
    | '/'
    | '/$workspaceId/agent'
    | '/$workspaceId/'
    | '/$workspaceId/entities'
    | '/$workspaceId/patterns'
    | '/$workspaceId/agent/'
    | '/$workspaceId/claims'
    | '/$workspaceId/coverage'
    | '/$workspaceId/decision'
    | '/$workspaceId/evidence'
    | '/$workspaceId/files'
    | '/$workspaceId/governance'
    | '/$workspaceId/home'
    | '/$workspaceId/topics'
    | '/$workspaceId/claims/$claimId'
    | '/$workspaceId/patterns/$patternId'
    | '/$workspaceId/agent/$conversationId'
    | '/$workspaceId/topics/$topicId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/logout'
    | '/sign-in'
    | '/callback'
    | '/forgot-password'
    | '/'
    | '/$workspaceId'
    | '/$workspaceId/entities'
    | '/$workspaceId/patterns'
    | '/$workspaceId/agent'
    | '/$workspaceId/claims'
    | '/$workspaceId/coverage'
    | '/$workspaceId/decision'
    | '/$workspaceId/evidence'
    | '/$workspaceId/files'
    | '/$workspaceId/governance'
    | '/$workspaceId/home'
    | '/$workspaceId/topics'
    | '/$workspaceId/claims/$claimId'
    | '/$workspaceId/patterns/$patternId'
    | '/$workspaceId/agent/$conversationId'
    | '/$workspaceId/topics/$topicId'
  id:
    | '__root__'
    | '/(auth)'
    | '/_authenticated'
    | '/logout'
    | '/_authenticated/$workspaceId'
    | '/(auth)/sign-in'
    | '/(auth)/callback'
    | '/(auth)/forgot-password'
    | '/_authenticated/'
    | '/_authenticated/$workspaceId/agent'
    | '/_authenticated/$workspaceId/'
    | '/_authenticated/$workspaceId/entities/'
    | '/_authenticated/$workspaceId/patterns/'
    | '/_authenticated/$workspaceId/agent/'
    | '/_authenticated/$workspaceId/claims/'
    | '/_authenticated/$workspaceId/coverage/'
    | '/_authenticated/$workspaceId/decision/'
    | '/_authenticated/$workspaceId/evidence/'
    | '/_authenticated/$workspaceId/files/'
    | '/_authenticated/$workspaceId/governance/'
    | '/_authenticated/$workspaceId/home/'
    | '/_authenticated/$workspaceId/topics/'
    | '/_authenticated/$workspaceId/claims/$claimId/'
    | '/_authenticated/$workspaceId/patterns/$patternId/'
    | '/_authenticated/$workspaceId/agent/$conversationId/'
    | '/_authenticated/$workspaceId/topics/$topicId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  authRouteRoute: typeof authRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LogoutRoute: typeof LogoutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/callback': {
      id: '/(auth)/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof authCallbackLazyRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/_authenticated/$workspaceId': {
      id: '/_authenticated/$workspaceId'
      path: '/$workspaceId'
      fullPath: '/$workspaceId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$workspaceId/': {
      id: '/_authenticated/$workspaceId/'
      path: '/'
      fullPath: '/$workspaceId/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/agent': {
      id: '/_authenticated/$workspaceId/agent'
      path: '/agent'
      fullPath: '/$workspaceId/agent'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdAgentRouteRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/topics/': {
      id: '/_authenticated/$workspaceId/topics/'
      path: '/topics'
      fullPath: '/$workspaceId/topics'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdTopicsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/home/': {
      id: '/_authenticated/$workspaceId/home/'
      path: '/home'
      fullPath: '/$workspaceId/home'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdHomeIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/governance/': {
      id: '/_authenticated/$workspaceId/governance/'
      path: '/governance'
      fullPath: '/$workspaceId/governance'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdGovernanceIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/files/': {
      id: '/_authenticated/$workspaceId/files/'
      path: '/files'
      fullPath: '/$workspaceId/files'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdFilesIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/evidence/': {
      id: '/_authenticated/$workspaceId/evidence/'
      path: '/evidence'
      fullPath: '/$workspaceId/evidence'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdEvidenceIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/decision/': {
      id: '/_authenticated/$workspaceId/decision/'
      path: '/decision'
      fullPath: '/$workspaceId/decision'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdDecisionIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/coverage/': {
      id: '/_authenticated/$workspaceId/coverage/'
      path: '/coverage'
      fullPath: '/$workspaceId/coverage'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdCoverageIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/claims/': {
      id: '/_authenticated/$workspaceId/claims/'
      path: '/claims'
      fullPath: '/$workspaceId/claims'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdClaimsIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/agent/': {
      id: '/_authenticated/$workspaceId/agent/'
      path: '/'
      fullPath: '/$workspaceId/agent/'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdAgentIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdAgentRouteRoute
    }
    '/_authenticated/$workspaceId/patterns/': {
      id: '/_authenticated/$workspaceId/patterns/'
      path: '/patterns'
      fullPath: '/$workspaceId/patterns'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdPatternsIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/entities/': {
      id: '/_authenticated/$workspaceId/entities/'
      path: '/entities'
      fullPath: '/$workspaceId/entities'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdEntitiesIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/topics/$topicId/': {
      id: '/_authenticated/$workspaceId/topics/$topicId/'
      path: '/topics/$topicId'
      fullPath: '/$workspaceId/topics/$topicId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/agent/$conversationId/': {
      id: '/_authenticated/$workspaceId/agent/$conversationId/'
      path: '/$conversationId'
      fullPath: '/$workspaceId/agent/$conversationId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdAgentRouteRoute
    }
    '/_authenticated/$workspaceId/patterns/$patternId/': {
      id: '/_authenticated/$workspaceId/patterns/$patternId/'
      path: '/patterns/$patternId'
      fullPath: '/$workspaceId/patterns/$patternId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdPatternsPatternIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
    '/_authenticated/$workspaceId/claims/$claimId/': {
      id: '/_authenticated/$workspaceId/claims/$claimId/'
      path: '/claims/$claimId'
      fullPath: '/$workspaceId/claims/$claimId'
      preLoaderRoute: typeof AuthenticatedWorkspaceIdClaimsClaimIdIndexRouteImport
      parentRoute: typeof AuthenticatedWorkspaceIdRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authSignInRoute: typeof authSignInRoute
  authCallbackLazyRoute: typeof authCallbackLazyRoute
  authForgotPasswordLazyRoute: typeof authForgotPasswordLazyRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authSignInRoute: authSignInRoute,
  authCallbackLazyRoute: authCallbackLazyRoute,
  authForgotPasswordLazyRoute: authForgotPasswordLazyRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface AuthenticatedWorkspaceIdAgentRouteRouteChildren {
  AuthenticatedWorkspaceIdAgentIndexLazyRoute: typeof AuthenticatedWorkspaceIdAgentIndexLazyRoute
  AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute: typeof AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute
}

const AuthenticatedWorkspaceIdAgentRouteRouteChildren: AuthenticatedWorkspaceIdAgentRouteRouteChildren =
  {
    AuthenticatedWorkspaceIdAgentIndexLazyRoute:
      AuthenticatedWorkspaceIdAgentIndexLazyRoute,
    AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute:
      AuthenticatedWorkspaceIdAgentConversationIdIndexLazyRoute,
  }

const AuthenticatedWorkspaceIdAgentRouteRouteWithChildren =
  AuthenticatedWorkspaceIdAgentRouteRoute._addFileChildren(
    AuthenticatedWorkspaceIdAgentRouteRouteChildren,
  )

interface AuthenticatedWorkspaceIdRouteRouteChildren {
  AuthenticatedWorkspaceIdAgentRouteRoute: typeof AuthenticatedWorkspaceIdAgentRouteRouteWithChildren
  AuthenticatedWorkspaceIdIndexRoute: typeof AuthenticatedWorkspaceIdIndexRoute
  AuthenticatedWorkspaceIdEntitiesIndexRoute: typeof AuthenticatedWorkspaceIdEntitiesIndexRoute
  AuthenticatedWorkspaceIdPatternsIndexRoute: typeof AuthenticatedWorkspaceIdPatternsIndexRoute
  AuthenticatedWorkspaceIdClaimsIndexLazyRoute: typeof AuthenticatedWorkspaceIdClaimsIndexLazyRoute
  AuthenticatedWorkspaceIdCoverageIndexLazyRoute: typeof AuthenticatedWorkspaceIdCoverageIndexLazyRoute
  AuthenticatedWorkspaceIdDecisionIndexLazyRoute: typeof AuthenticatedWorkspaceIdDecisionIndexLazyRoute
  AuthenticatedWorkspaceIdEvidenceIndexLazyRoute: typeof AuthenticatedWorkspaceIdEvidenceIndexLazyRoute
  AuthenticatedWorkspaceIdFilesIndexLazyRoute: typeof AuthenticatedWorkspaceIdFilesIndexLazyRoute
  AuthenticatedWorkspaceIdGovernanceIndexLazyRoute: typeof AuthenticatedWorkspaceIdGovernanceIndexLazyRoute
  AuthenticatedWorkspaceIdHomeIndexLazyRoute: typeof AuthenticatedWorkspaceIdHomeIndexLazyRoute
  AuthenticatedWorkspaceIdTopicsIndexLazyRoute: typeof AuthenticatedWorkspaceIdTopicsIndexLazyRoute
  AuthenticatedWorkspaceIdClaimsClaimIdIndexRoute: typeof AuthenticatedWorkspaceIdClaimsClaimIdIndexRoute
  AuthenticatedWorkspaceIdPatternsPatternIdIndexRoute: typeof AuthenticatedWorkspaceIdPatternsPatternIdIndexRoute
  AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRoute: typeof AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRoute
}

const AuthenticatedWorkspaceIdRouteRouteChildren: AuthenticatedWorkspaceIdRouteRouteChildren =
  {
    AuthenticatedWorkspaceIdAgentRouteRoute:
      AuthenticatedWorkspaceIdAgentRouteRouteWithChildren,
    AuthenticatedWorkspaceIdIndexRoute: AuthenticatedWorkspaceIdIndexRoute,
    AuthenticatedWorkspaceIdEntitiesIndexRoute:
      AuthenticatedWorkspaceIdEntitiesIndexRoute,
    AuthenticatedWorkspaceIdPatternsIndexRoute:
      AuthenticatedWorkspaceIdPatternsIndexRoute,
    AuthenticatedWorkspaceIdClaimsIndexLazyRoute:
      AuthenticatedWorkspaceIdClaimsIndexLazyRoute,
    AuthenticatedWorkspaceIdCoverageIndexLazyRoute:
      AuthenticatedWorkspaceIdCoverageIndexLazyRoute,
    AuthenticatedWorkspaceIdDecisionIndexLazyRoute:
      AuthenticatedWorkspaceIdDecisionIndexLazyRoute,
    AuthenticatedWorkspaceIdEvidenceIndexLazyRoute:
      AuthenticatedWorkspaceIdEvidenceIndexLazyRoute,
    AuthenticatedWorkspaceIdFilesIndexLazyRoute:
      AuthenticatedWorkspaceIdFilesIndexLazyRoute,
    AuthenticatedWorkspaceIdGovernanceIndexLazyRoute:
      AuthenticatedWorkspaceIdGovernanceIndexLazyRoute,
    AuthenticatedWorkspaceIdHomeIndexLazyRoute:
      AuthenticatedWorkspaceIdHomeIndexLazyRoute,
    AuthenticatedWorkspaceIdTopicsIndexLazyRoute:
      AuthenticatedWorkspaceIdTopicsIndexLazyRoute,
    AuthenticatedWorkspaceIdClaimsClaimIdIndexRoute:
      AuthenticatedWorkspaceIdClaimsClaimIdIndexRoute,
    AuthenticatedWorkspaceIdPatternsPatternIdIndexRoute:
      AuthenticatedWorkspaceIdPatternsPatternIdIndexRoute,
    AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRoute:
      AuthenticatedWorkspaceIdTopicsTopicIdIndexLazyRoute,
  }

const AuthenticatedWorkspaceIdRouteRouteWithChildren =
  AuthenticatedWorkspaceIdRouteRoute._addFileChildren(
    AuthenticatedWorkspaceIdRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedWorkspaceIdRouteRoute: typeof AuthenticatedWorkspaceIdRouteRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedWorkspaceIdRouteRoute:
    AuthenticatedWorkspaceIdRouteRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  authRouteRoute: authRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LogoutRoute: LogoutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
